var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopicSaludos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DCFCE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BBF7D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chatGradLeft",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#16A34A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#14532D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chatGradRight",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4ADE80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#15803D"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "url(#bgGrad)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32, 32)",
    filter: "drop-shadow(0px 3px 2px rgba(20, 83, 45, 0.15))"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10, -8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -14,
    y: -10,
    width: 28,
    height: 18,
    rx: 6,
    fill: "url(#chatGradLeft)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -4,8 L -10,14 L -8,8 Z",
    fill: "#14532D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: -4,
    x2: 8,
    y2: -4,
    stroke: "#F0FDF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 1,
    x2: 2,
    y2: 1,
    stroke: "#F0FDF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12, 6)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -13,
    y: -9,
    width: 26,
    height: 16,
    rx: 5,
    fill: "url(#chatGradRight)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4,7 L 9,12 L 7,7 Z",
    fill: "#15803D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -7,
    y1: -3,
    x2: 7,
    y2: -3,
    stroke: "#F0FDF4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: -7,
    y1: 2,
    x2: 1,
    y2: 2,
    stroke: "#F0FDF4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    opacity: 0.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicSaludos);
export default __webpack_public_path__ + "static/media/topic_saludos.1fae4c0903b85485672604813d7b7988.svg";
export { ForwardRef as ReactComponent };